import ct from "class-types.macro";
import React from "react";
import SocialMediaShareButton from "~/common/SocialMediaShare/SocialMediaShareButton";

interface Props {
  pinterestShareUrl: string;
  facebookShareUrl: string;
  twitterShareUrl: string;
}

export default function BlogSocialMediaShareIcons({
  pinterestShareUrl,
  facebookShareUrl,
  twitterShareUrl,
}: Props) {
  return (
    <div className={ct("flex", "mt-4")}>
      <SocialMediaShareButton site="Facebook" shareUrl={facebookShareUrl} />
      <SocialMediaShareButton site="Pinterest" shareUrl={pinterestShareUrl} />
      <SocialMediaShareButton site="Twitter" shareUrl={twitterShareUrl} />
    </div>
  );
}
